import { render } from "./FourZeroFourComponent.vue?vue&type=template&id=d8a67cf2"
import script from "./FourZeroFourComponent.vue?vue&type=script&lang=js"
export * from "./FourZeroFourComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__